import React from 'react'
import SectionContainer from '../../../Homepage/SectionContainer'
import BreadCrumb from '../../../component/BreadCrumb/BreadCrumb'
import MediumButton from '../../../component/button/MediumButton'
import VisaImg from "../../../assets/kangaroo/AustraliaBanner.jpg"
import { data } from '../data'
import { Col, Row } from 'reactstrap'
import SmallPage from '../../../Homepage/SmallPage'
import DynamicInlineForm from '../../../component/DynamicInline/DynamicInlineForm'
import Map from '../../../Homepage/Map'
const Tax = () => {
  const taxData = data
  return (
    <>
    <div
        className="hero-banner"
        style={{ "--banner-img": `url(${VisaImg})`, overflow: "hidden" }}
      >
        <SectionContainer className="d-flex align-items-center h-100">
          <BreadCrumb
            items={[
              { title: "HOME", link: "/" },
              { title: "SERVICES", link: "/services" },
              { title: "TAX RETURN", },
            ]}
          />
          <div className=" page-content text-start h-100 d-flex flex-column justify-content-center">
            <h1 className="banner-text-country lh-1">
              VISA AND MIGRATION
            </h1>
            <div>
            <MediumButton
                label="GET SUPPORT NOW"
                career={true}
                fill="transparent"
                textColor="#821790"
                width={250}
                height={80}
                fontSize={24}
              />
            </div>
          </div>
        </SectionContainer>
      </div>
      <SectionContainer>
        <p className='country-paragraph-text'>{taxData[0].content}</p>
        <h1 className='font-level-8'style={{marginTop:"71px", marginBottom:"31px"}}>When Are Tax Return Due In Australia?</h1>
        <pre className='country-paragraph-text' style={{ marginBottom:"77px"}}>{taxData[1].taxReturn}</pre>
        
      </SectionContainer>
      <SectionContainer mainId="ielts-prep-subpage" >
        <Row style={{marginTop:"6rem"}}> 
          <Col>
            <h1 className="font-heading">
              Reserve Your One-to-One Tax Return Assistance Session
            </h1>
            <p className="country-paragraph-text mt-3 mb-4">
             Provide your details and choose a convenient date and time, our team will guide you through accurate tax filing, compliance, and essential financial obligations.
            </p>
          </Col>
        </Row>

        <DynamicInlineForm
          fullName={true}
          emailAddress={true}
          phoneNumber={true}
          studyLevel={true}
          callBackTime={true}
          nearestOffice={true}
          message={true}
          buttondesc="BOOK YOUR SESSION"
        />
        
      </SectionContainer>
      <SectionContainer>
        <h1 className='font-level-8'style={{marginTop:"71px", marginBottom:"31px"}}>How can we help you with Tax Returns?</h1>
        <pre className='country-paragraph-text'>{taxData[2].taxReturnHelp}</pre>
      </SectionContainer>
      <hr className='line' style={{marginTop:"166px"}}/>
      <SectionContainer>
        <Map/>
        <hr className='line-style-testprep' />
        <SmallPage countryPage={true}/>
      </SectionContainer>


    </>
  )
}

export default Tax